export const QUESTION_STAGE_TYPES = Object.freeze({
  REVEALED: 'question-revealed',
  GRACE_PERIOD: 'question-grace-period',
  SCORE_DECAY_STARTED: 'score-decay-started',
  CLOSED: 'question-closed',
  SHOW_ANSWER: 'show-answer',
});

export const QUESTION_PHASES = QUESTION_STAGE_TYPES;
